(() => {
  const init = (root) => {
    if (!root || root.dataset.mchReady) return;
    root.dataset.mchReady = 'true';
    const selectors = root.querySelector('[data-mch-hero-selectors]');
    selectors.hidden = false;
    selectors.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        selectors.querySelectorAll('button').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        root.querySelectorAll('[data-mch-hero-device]').forEach((image) => image.classList.toggle('is-featured', image.dataset.mchHeroDevice === button.dataset.mchHeroSelect));
      });
    });
    const tabs = root.querySelector('[data-mch-tabs]');
    const examples = root.querySelector('[data-mch-examples]');
    tabs.hidden = false;
    const categoryButtons = [...tabs.querySelectorAll('button')];
    const cards = [...examples.querySelectorAll('[data-mch-example]')];
    const markCategory = (category) => categoryButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mchCategory === category)));
    const syncCategory = () => {
      const start = cards[0].offsetLeft;
      const nearest = cards.reduce((best, card) => Math.abs(card.offsetLeft - start - examples.scrollLeft) < Math.abs(best.offsetLeft - start - examples.scrollLeft) ? card : best);
      markCategory(nearest.dataset.mchExample);
    };
    const selectCategory = (button) => {
      const category = button.dataset.mchCategory;
      const card = root.querySelector(`[data-mch-example="${category}"]`);
      markCategory(category);
      examples.scrollLeft = card.offsetLeft - examples.querySelector('[data-mch-example]').offsetLeft;
    };
    categoryButtons.forEach((button) => button.addEventListener('click', () => selectCategory(button)));
    let categoryFrame = 0;
    examples.addEventListener('scroll', () => {
      if (categoryFrame) return;
      categoryFrame = requestAnimationFrame(() => { categoryFrame = 0; syncCategory(); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(syncCategory).observe(examples);
    selectCategory(tabs.querySelector('button'));
    root.querySelectorAll('.mch-scroll').forEach((track) => {
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        const moves = { ArrowRight: track.clientWidth * .8, ArrowLeft: -track.clientWidth * .8, Home: -track.scrollWidth, End: track.scrollWidth };
        if (!(event.key in moves)) return;
        event.preventDefault();
        track.scrollBy({ left: moves[event.key], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
  };
  document.querySelectorAll('[data-mch-home]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-mch-home]')));
})();
